import SvgIcon from "@mui/material/SvgIcon";

// No MUI icon matches the plain wireframe-cube look this app wants for "package" (Inventory2
// is a closed carton, ViewInAr adds AR viewfinder corner brackets) — this is the User App's
// own "box" icon (web_user_v2/src/components/Icon.tsx's PATHS.box) ported over verbatim
// instead of a hand-drawn approximation, so it's pixel-for-pixel the same shape on both apps.
// Wrapped in MUI's own SvgIcon so it inherits currentColor/fontSize/sx exactly like every
// other icon around it (AppShell's nav, and the "Zakazani članovi" row actions). One shape
// covers every place this is used — it's already just an outline, no separate filled variant.
const PackageCubeIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M3.5 7.5L12 3.5l8.5 4-8.5 4-8.5-4z" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M3.5 7.5v9l8.5 4 8.5-4v-9" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M12 11.5v9" stroke="currentColor" strokeWidth="1.7" />
  </SvgIcon>
);

export default PackageCubeIcon;
